export function stripCepDigits(value: string): string {
  return value.replace(/\D/g, '').slice(0, 8);
}

export function formatCepDisplay(digits: string): string {
  const value = stripCepDigits(digits);

  if (value.length <= 5) {
    return value;
  }

  return `${value.slice(0, 5)}-${value.slice(5)}`;
}
